<template>
  <vs-popup class="import-popup" title="Excel 업로드" :active.sync="popupActive">
    <div>
      <input type="file" ref="fileInput" class="hidden" @change="handleClick" accept=".xlsx">
      <div
        @click="$refs.fileInput.click()"
        @drop="handleDrop"
        @dragover="handleDragover"
        @dragenter="handleDragenter"
        @dragleave="handleDragleave"
        class="px-10 py-16 cursor-pointer text-center border-2 border-dashed d-theme-dark-bg text-xl mb-4"
        :style="'border-color: ' + (dragCounter==0?'#dae1e7':'#427FEB') + ';'">
        <feather-icon icon="FileTextIcon" svgClasses="h-16 w-16 stroke-current text-grey" class="block" />
        <span v-if="datas.length==0">Excel 파일 드래그 또는&nbsp;</span>
        <span v-else>{{ fileName }}</span>
        <span v-if="datas.length==0" class="font-medium text-primary" @click.stop="$refs.fileInput.click()">찾아보기</span>
        <span v-else class="font-medium text-primary"> ({{ datas.length }}건)</span>
        <!-- <vs-button type="border" @click.stop="$refs.fileInput.click()">Browse</vs-button> -->
      </div>
    </div>
    <!-- <div v-else class="mb-4 py-24 text-center text-2xl">
      총 {{ datas.length }}건
    </div> -->
    <div class="text-center">
      <vs-button @click="save" :disabled="datas.length==0">등록</vs-button>
    </div>
  </vs-popup>
</template>

<script>
import XLSX from 'xlsx'
import dateFormat from 'dateformat'

export default {
  data () {
    return {
      popupActive: false,
      dragCounter: 0,
      fileName: '',
      datas: []
    }
  },
  methods: {
    open () {
      this.popupActive = true
      this.dragCounter = 0
      this.datas = []
    },
    handleDragover (e) {
      e.stopPropagation()
      e.preventDefault()
      e.dataTransfer.dropEffect = 'copy'
    },
    handleDragenter (e) {
      e.stopPropagation()
      e.preventDefault()
      this.dragCounter++
      e.dataTransfer.dropEffect = 'copy'
    },
    handleDragleave (e) {
      e.stopPropagation()
      e.preventDefault()
      this.dragCounter--
    },
    handleDrop (e) {
      e.stopPropagation()
      e.preventDefault()
      this.dragCounter--
      const files = e.dataTransfer.files
      if (files.length !== 1) {
        this.$vs.notify({
          title: '업로드 실패',
          text: '한개의 파일만 업로드가 가능합니다.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
        return
      }
      const rawFile = files[0] // only use files[0]
      if (!this.isExcel(rawFile)) {
        this.$vs.notify({
          title: '업로드 실패',
          text: 'Excel 파일만 업로드가 가능합니다. (.xlsx)',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
        return false
      }
      this.uploadFile(rawFile)
    },
    handleClick (e) {
      const files = e.target.files
      const rawFile = files[0]
      if (!rawFile) return
      this.uploadFile(rawFile)
    },
    isExcel (file) {
      return /\.(xlsx)$/.test(file.name)
    },
    uploadFile (file) {
      this.fileName = file.name
      this.$refs['fileInput'].value = null // fix can't select the same excel
      this.readerData(file)
    },
    readerData (rawFile) {
      return new Promise((resolve) => {
        this.$vs.loading()
        const reader = new FileReader()
        reader.onload = e => {
          const data = e.target.result
          const workbook = XLSX.read(data, { type: 'array', cellDates: true })
          const firstSheetName = workbook.SheetNames[0]
          const worksheet = workbook.Sheets[firstSheetName]
          const results = XLSX.utils.sheet_to_json(worksheet)
          this.generateData(results)
          this.$vs.loading.close()
          resolve()
        }
        reader.readAsArrayBuffer(rawFile)
      })
    },
    generateData (results) {
      for (const key in results) {
        // var result = results[key]
        const result = this.trimKeys(results[key])
        const data = {
          vendor: result['제작사'],
          status: result['상태'],
          municipality: result['지자체'],
          municipality2: result['운행지자체'],
          region: result['운행지역'],
          etc: result['기타'],
          vehicleName: result['차명'],
          structureChangeDate: (result['구조변경일'] instanceof Date) ? dateFormat(result['구조변경일'], 'yyyy-mm-dd') : result['구조변경일'],
          vehicleId: result['차대번호'],
          address: result['주소'],
          ownerName: result['소유자명'],
          vehicleNumber: result['차량번호'],
          currentVehicleNumber: result['현재차량번호'],
          phone: result['연락처'],
          lastPhone: result['최종연락처'],
          prevCleaningDate: (result['이전클리닝일자'] instanceof Date) ? dateFormat(result['이전클리닝일자'], 'yyyy-mm-dd') : result['이전클리닝일자'],
          lastCleaningDate: (result['최종클리닝일시'] instanceof Date) ? dateFormat(result['최종클리닝일시'], 'yyyy-mm-dd') : result['최종클리닝일시'],
          engineer: result['처리기사'],
          cleaningType: result['클리닝방법'],     // 없음
          remainSubsidy: result['잔여보조금'],
          reservationDate: (result['예약날짜'] instanceof Date) ? dateFormat(result['예약날짜'], 'yyyy-mm-dd') : result['예약날짜'],
          workDate: result['작업일자'],
          special: result['정기/특별'],
          requestReason: result['요청사유'],
          listSchedule: (result['리스트일정'] instanceof Date) ? dateFormat(result['리스트일정'], 'yyyy-mm-dd') : result['리스트일정'],
          remark: result['비고'],
          note: result['참고사항/전달사항'],
          mileage: result['주행거리'],
          serial1: result['전시리얼'],
          serial2: result['후시리얼'],
          smoke1: result['전매연'],
          smoke2: result['후매연'],
          backPressure1: result['전배압'],
          backPressure2: result['후배압'],
          certificationNumber: result['인증번호'],
          vehicleType: result['차종'],
          usage: result['용도'],
          createdDatetime: this.$firestore.FieldValue.serverTimestamp(),
          modifiedDatetime: this.$firestore.FieldValue.serverTimestamp(),
          modifiedContent: '심사 등록',
          modifiedManager: this.$store.state.AppActiveUser.displayName
        }
        for (const key2 in data) {
          if (data[key2] === undefined) {
            data[key2] = null
          }
        }
        if (data.id === null) {
          continue
        }
        this.datas.push(data)
      }
    },
    trimKeys (data) {
      const data2 = {}
      for (const key in data) {
        data2[key.replace(/\s\n*/g, '')] = data[key]
      }
      return data2
    },
    getVehicleNumbers (audit) {
      const vehicleNumbers = []
      if (audit.vehicleNumber) {
        vehicleNumbers.push(String(audit.vehicleNumber))
        vehicleNumbers.push(String(audit.vehicleNumber).slice(-4, audit.vehicleNumber.length))
      }
      if (audit.currentVehicleNumber) {
        vehicleNumbers.push(String(audit.currentVehicleNumber))
        vehicleNumbers.push(String(audit.currentVehicleNumber).slice(-4, audit.currentVehicleNumber.length))
      }
      return vehicleNumbers
    },
    getPhoneNumbers (audit) {
      const phoneNumbers = []
      if (audit.phone) {
        phoneNumbers.push(String(audit.phone))
        phoneNumbers.push(String(audit.phone).slice(-4, audit.phone.length))
      }
      if (audit.lastPhone) {
        phoneNumbers.push(String(audit.lastPhone))
        phoneNumbers.push(String(audit.lastPhone).slice(-4, audit.lastPhone.length))
      }
      return phoneNumbers
    },
    async save () {
      this.$vs.loading()
      let batch = this.$db.batch()
      let i = 0
      for (const key in this.datas) {
        const data = this.datas[key]
        data.vehicleNumbers = this.getVehicleNumbers(data)
        data.phoneNumbers = this.getPhoneNumbers(data)
        batch.set(this.$db.collection('installations').doc(), data)
        i++
        if (i === 249) {
          i = 0
          await batch.commit()
          batch = this.$db.batch()
        }
      }
      batch.commit().then(() => {
        this.$vs.loading.close()
        this.$emit('reload')
        this.popupActive = false
      })
    }
  }
}
</script>

<style lang="scss">
.import-popup .vs-popup {
  width: 1000px !important;
}
</style>
